import { render, staticRenderFns } from "./Attribute.vue?vue&type=template&id=0161da8c&scoped=true"
import script from "./Attribute.vue?vue&type=script&lang=ts"
export * from "./Attribute.vue?vue&type=script&lang=ts"
import style0 from "./Attribute.vue?vue&type=style&index=0&id=0161da8c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0161da8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0161da8c')) {
      api.createRecord('0161da8c', component.options)
    } else {
      api.reload('0161da8c', component.options)
    }
    module.hot.accept("./Attribute.vue?vue&type=template&id=0161da8c&scoped=true", function () {
      api.rerender('0161da8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/Attribute.vue"
export default component.exports